/**
 * Full-screen error shown when login service is unreachable.
 * @param {{ onRetry?: () => void }} props
 */
export function LoginFailedScreen({ onRetry }) {
  const handleRetry = () => {
    onRetry?.();
    window.location.reload();
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', padding: '2rem', textAlign: 'center' }}>
      <div style={{ maxWidth: '400px' }}>
        <h2 style={{ color: '#dc2626', marginBottom: '1rem' }}>无法连接服务器</h2>
        <p style={{ color: '#6b7280', marginBottom: '1.5rem' }}>
          登录服务暂时不可用，请稍后重试。
        </p>
        <button
          onClick={handleRetry}
          style={{ padding: '0.75rem 1.5rem', backgroundColor: '#3b82f6', color: 'white', border: 'none', borderRadius: '8px', fontSize: '1rem', fontWeight: 500, cursor: 'pointer' }}
        >
          重试
        </button>
      </div>
    </div>
  );
}
